import axios from 'axios';

export const ISSUE_APPOINTMENT_LOADING = 'ISSUE_APPOINTMENT_LOADING';
export const ISSUE_APPOINTMENT_SUCCESS = 'ISSUE_APPOINTMENT_SUCCESS';
export const ISSUE_APPOINTMENT_ERROR = 'ISSUE_APPOINTMENT_ERROR';

export function fetchAppointment(appointmentId) {
  return async (dispatch, getState) => {
    const state = getState();

    if (!state.user.token) {
      return;
    }

    dispatch({ type: ISSUE_APPOINTMENT_LOADING });
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/admin/appointments/${appointmentId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${state.user.token}`
        }
      })
      .then(response => {
        dispatch({
          type: ISSUE_APPOINTMENT_SUCCESS,
          payload: response
        });
      })
      .catch(result => {
        dispatch({
          type: ISSUE_APPOINTMENT_ERROR,
          payload: result
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/Admin/appointmentActions.js